import React from "react";
import PropTypes from "prop-types";
import ReactEchartsCore from "echarts-for-react/lib/core";
import echarts from "echarts/lib/echarts";
import "echarts/lib/component/title";

import "echarts/lib/chart/bar";

import NHFetch from "../../utils/NHFetch.js";

const yxxtBasicUrl = "api/zhxg-yxxt"; //迎新管理服务后台接口基础路径
const errMaxCount = 3; // 请求异常最大次数
const speed = 60 * 1000; //轮询时间间隔

/**
 * * 专业报到率排名条形统计图
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-07-04
 * Version: 1.0
 * Modify log:
 */
class IndexComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            errCount: 0, //连续请求错误次数
            barData: [], //各专业新生人数
        };

        this.polling; //轮询定时器
    }

    componentDidMount() {
        this.getData();
    }

    componentWillUnmount() {
        //组件卸载时清除轮询定时器
        if (this.polling) {
            clearTimeout(this.polling);
        }
    }

    /**
     * * 环节专业新生人数数据
     * @memberof IndexComponent
     */
    getData = () => {
        NHFetch(yxxtBasicUrl + "/sstj/getStatisticsForProfessionalReported", "GET") //getStatisticsForProfessionalReported
            .then((res) => {
                if (res && res.data) {
                    //由于专业新生人数是一开始就确定的，所以这里只有当出现异常的时候才进行轮询尝试
                    let dataFormat = [];
                    let data = res.data;

                    // let data = [
                    //     {zymc: "计算机", bdl: 0},
                    //     {zymc: "计算机科学与技术", bdl: 0.2856},
                    //     {zymc: "测试专业长度为一二三", bdl: 0.1855},
                    //     {zymc: "测试专业长度为一二", bdl: 0.4854},
                    //     {zymc: "测试专业长度为一", bdl: 0.1755},
                    //     {zymc: "测试专业度为", bdl: 0.4555},
                    //     {zymc: "测试专业长度为一", bdl: 0.7},
                    //     {zymc: "测试专业长度为", bdl: 0.83},
                    //     {zymc: "测试专业长度", bdl: 0.98345},
                    //     {zymc: "测试专业长度为一二", bdl: 1},
                    // ];

                    for (let i of data) {
                        let obj = {};
                        obj.bdl = this.transformDecimal(i.bdl * 100, 1).toFixed(1);
                        obj.zymc = i.zymc;
                        dataFormat.push(obj)
                    }
                    this.polling = setTimeout(() => {
                      this.getData();
                    }, speed);
                    this.setState({errCount: 0, barData: dataFormat});
                }
            })
            .catch((err) => {
                let errCount = this.state.errCount;
                //如果请求异常次数未超过最大次数限制，则继续尝试
                if (errCount < errMaxCount) {
                    this.polling = setTimeout(() => {
                        this.getData();
                    }, speed);
                    this.setState({errCount: errCount + 1});
                } else {
                    //异常超过3次后终止轮询
                    if (this.polling) {
                        clearTimeout(this.polling);
                    }
                }
            });
    };

    /**
     * * 构造报到率排前十的专业条形统计图
     * @memberof Home
     */
    getBarOption = () => {
        const {barData = []} = this.state;

        // 对数据进行排序
        barData.sort(function (a, b) {
            return b.bdl - a.bdl;
        });

        let sortedTopTenMajor = barData.slice(0, 10);

        const {rem} = this.props;

        // y轴标题(专业名称)
        let yAxisTitles = sortedTopTenMajor.map((item) => {
            return item.zymc ? item.zymc : "";
        });

        // y轴值
        let yAxisData = sortedTopTenMajor.map((item) => {
            return item.bdl;
        });
        // y轴框
        let yAxisFrame = sortedTopTenMajor.map((item) => {
            return 100;
        });

        const option = {
            title: {
                text: "报到率前十专业",
                textStyle: {
                    color: "#05ffe3",
                    fontSize: 0.18 * rem,
                    fontWeight: 100,
                },
            },
            grid: {
                top: "8%",
                left: '-27%',
                bottom: "3%",
                containLabel: true,
            },
            xAxis: {
                show: false,
            },
            yAxis: [
                {
                    show: true,
                    data: yAxisTitles,
                    inverse: true,
                    axisLine: {
                        show: false,
                    },
                    splitLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        formatter: (value, index) => {
                            //专业名字过长时，超过8个字则换行
                            let titleStr = [];
                            if (value.length > 0) {
                                let count = value.length > 8 ? 2 : 1;
                                for (let i = 0; i < count; i++) {
                                    if (i === 0) {
                                        titleStr.push(
                                            `{lg|${index + 1}}  ` +
                                            "{title|" +
                                            value.substr(0, 8).padEnd(8, "") +
                                            "} "
                                        );
                                    } else {
                                        titleStr.push(
                                            "{title|        " + value.substr(8, 8) + "} "
                                        );
                                    }
                                }
                            }

                            return titleStr.length > 1
                                ? titleStr.join("\n")
                                : titleStr.join("");
                        },
                        margin: 130,
                        textStyle: {
                            fontSize: 0.14 * rem,
                            align: "left",
                        },
                        rich: {
                            lg: {
                                backgroundColor: "#74dafc",
                                color: "#18306F",
                                borderRadius: 0.18 * rem,
                                align: "center",
                                width: 0.18 * rem,
                                height: 0.18 * rem,
                            },
                            title: {
                                color: "#00ffca",
                            },
                        },
                    },
                },
                {
                    show: true,
                    inverse: true,
                    data: yAxisData.map((item, index) => {
                        return item + "%";
                    }),
                    axisLabel: {
                        textStyle: {
                            fontSize: 0.14 * rem,
                            color: "#fce412",
                        },
                    },
                    axisLine: {
                        show: false,
                    },
                    splitLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                },
            ],
            series: [
                {
                    name: "条",
                    type: "bar",
                    barMaxWidth: 0.14 * rem,
                    // barMinHeight: 1,
                    yAxisIndex: 0,
                    data: yAxisData,
                    silent: false,
                    barCategoryGap: "60%",
                    itemStyle: {
                        normal: {
                            barBorderRadius: 0.2 * rem,
                            color: {
                                type: "bar",
                                colorStops: [
                                    {
                                        offset: 0,
                                        color: "#00ffca", // 0% 处的颜色
                                    },
                                    {
                                        offset: 1,
                                        color: "#fce412", // 100% 处的颜色
                                    },
                                ],
                                globalCoord: false, // 缺省为 false
                            },
                        },
                    },
                },
                {
                    name: "框",
                    type: "bar",
                    barMaxWidth: 0.14 * rem,
                    barMinHeight: 1,
                    yAxisIndex: 1,
                    data: yAxisFrame,
                    silent: false,
                    barCategoryGap: "60%",
                    itemStyle: {
                        normal: {
                            barBorderRadius: 0.2 * rem,
                            borderColor: {
                                type: "bar",
                                colorStops: [
                                    {
                                        offset: 0,
                                        color: "#00ffca", // 0% 处的颜色
                                    },
                                    {
                                        offset: 1,
                                        color: "#fce412", // 100% 处的颜色
                                    },
                                ],
                                globalCoord: false, // 缺省为 false
                            },
                            borderWidth: 1,
                            color: "transparent",
                        },
                    },
                },
            ],
        };
        return option;
    };

    transformDecimal = (number, i) => {
        let decimalNum = null;
        // 先转换为数值型
        let num = Number(number);
        // 判断是否为数值型
        if (!isNaN(num)) {
            // 切分整数与小数
            let arr = num.toString().split(".");
            // 是小数且小数位大于保留个数
            if (arr.length > 1 && arr[1].length > i) {
                // 小数部分字符串
                let decimal = arr[1].slice(i, i + 1);
                // toFixed 有 bug，四舍六入五随机
                // 当四舍五入的数为 5，给其 + 1
                if (decimal === '5') {
                    // 这里可能会存在 0.1 ** 5 = 0.000010000000000000003 但不影响四舍五入
                    num += Math.pow(0.1, i + 1);
                }
                decimalNum = num.toFixed(i);
            } else {
                decimalNum = num;
            }
            decimalNum = Number(decimalNum);
        }
        return decimalNum;
    }


    render() {
        return (
            <div style={{width: "100%", height: "100%"}}>
                <ReactEchartsCore
                    style={{width: "100%", height: "100%"}}
                    echarts={echarts}
                    option={this.getBarOption()}
                    notMerge={true}
                    lazyUpdate={true}
                />
            </div>
        );
    }
}

IndexComponent.defaultProps = {};

IndexComponent.propTypes = {
    rem: PropTypes.number,
};

export default IndexComponent;



// WEBPACK FOOTER //
// ./containers/Show-gdnh/_BarBox2.js